var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-checkbox',{attrs:{"true-label":1,"false-label":0},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._v("\n        "+_vm._s(_vm.model ? 'Yes' : 'No')+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }